module.exports = __webpack_public_path__ + "img/nokialogo.b4ce7ed0.png";